import React from "react";

export default function SubHeading(props) {
  return (
    <div className="text-[#A3A3A3] opacity-50 font-sans font-light text-base">
      {props.content}
    </div>
  );
}
